import { Component, Element, h, Prop, State } from '@stencil/core';


@Component({
    tag: 'app-pageselector',
    styleUrl: 'app-pageselector.scss'
})
export class AppPageselector {

    @Element() root: HTMLElement;
    @Prop() selectorTitle: string;
    @Prop() buttonText: string;
    @State() currentItem: string;
    @State() menuOpen: boolean;

    componentWillLoad() {
        const items: any = this.root.querySelectorAll('.app-pageselector__item');
        if (items.length > 0) {
            this.currentItem = items[0].innerHTML;
        }
    }

    componentDidLoad() {
        const items: any = this.root.querySelectorAll('.app-pageselector__item');

        items.forEach((item: HTMLAnchorElement, index: Number) => {
            item.onclick = (e) => {
                e.preventDefault()
                this.currentItem = item.innerHTML;
                this.menuOpen = false;
            }

            if (index === items.length - 1) {
                item.onkeydown = (e) => {
                    if (!e.shiftKey && e.key.toLowerCase() === 'tab') {
                        this.menuOpen = false;
                    }
                }
            }
        });

        //======== handle click outside
        // Get the element to exclude
        const excludedElement = document.querySelector('.app-pageselector__selector');

        document.addEventListener('click', (event) => {
            // Check if the clicked element or any of its parents match the excluded element
            if (event.target === excludedElement || excludedElement.contains(event.target as Node)) {
                // Clicked on the excluded element or its children
                return;
            }

            // Clicked outside the excluded element
            this.menuOpen = false;
        });
    }

    toggleMenu() {
        if (!this.menuOpen) {
            this.menuOpen = true;
        } else {
            this.menuOpen = false
        }
    }

    handlekeyDown(event: KeyboardEvent) {
        if (event.key.toLowerCase() === 'enter') {
            this.menuOpen = true;
        } else if (event.shiftKey && event.key.toLowerCase() === 'tab') {
            this.menuOpen = false
        }
    }

    goToPage(e) {
        e.preventDefault();
        const items: any = this.root.querySelectorAll('.app-pageselector__item');

        items.forEach((item) => {
            if (item.innerHTML == this.currentItem) {
                let targetLocation = item.getAttribute('target');
                window.open(item.getAttribute('href'), targetLocation === '' ? '_self' : targetLocation);
            }
        });
    }

    render() {
        return (
            <div class="app-pageselector container">

                <div class="app-pageselector__inner">

                    {Boolean(this.selectorTitle) && (
                        <div class="app-pageselector__title">
                            {this.selectorTitle}:
                        </div>
                    )}

                    <div class={`app-pageselector__selector ${this.menuOpen ? '--open' : ''}`}>
                        <div
                            class="app-pageselector__menu"
                            role="button"
                            tabIndex={0}
                            aria-label="Select an option"
                            onClick={() => { this.toggleMenu() }}
                            onKeyDown={(e) => { this.handlekeyDown(e) }}
                        >
                            <span>{this.currentItem}</span>
                            <svg>
                                <use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#chevron-down"></use>
                            </svg>
                        </div>

                        <div class="app-pageselector__items">
                            <slot />
                        </div>
                    </div>

                    <button
                        class="btn btn-primary"
                        aria-label={this.buttonText ? this.buttonText : 'Go'}
                        onClick={(e) => { this.goToPage(e) }}>
                        {this.buttonText ? this.buttonText : 'Go'}
                    </button>
                </div>

            </div>
        );
    }
}

